import { useRef } from 'react';

export const internationalListComponentId = 'international-content';

const useScroll = (elementId?: string) => {
  const scrollY = useRef(0);

  const moveScroll = ({
    target,
    rememberPrevScrollTop = false,
  }: {
    target?: HTMLElement | null;
    rememberPrevScrollTop?: boolean;
  }) => {
    if (rememberPrevScrollTop) {
      scrollY.current = window.scrollY;
    }

    const scrollTarget = target?.offsetTop ? target.offsetTop + 10 : 0;
    window.scrollTo({ top: scrollTarget });
  };

  const restoreScroll = () => {
    if (scrollY.current) {
      window.scrollTo({ top: scrollY.current });
    } else if (elementId) {
      const targetElement = document.getElementById(elementId);
      targetElement?.scrollIntoView({ block: 'start' });
    }
  };

  return { scrollY, moveScroll, restoreScroll };
};

export default useScroll;
